import React from "react";
import config from "../configData.json";

export const createStore = (name: string): any => {
  if (window.sessionStorage.getItem(config.STORAGE_ROOT + name) === null) {
    window.sessionStorage.setItem(
      config.STORAGE_ROOT + name,
      JSON.stringify([])
    );
  }
};

export const clearStore = (name: string): any => {
  if (window.sessionStorage.getItem(config.STORAGE_ROOT + name) !== null) {
    window.sessionStorage.setItem(
      config.STORAGE_ROOT + name,
      JSON.stringify([])
    );
  }
};

export const getStore = (name: string): any => {
  let store: any;

  //do we have the store in session
  if (window.sessionStorage.getItem(config.STORAGE_ROOT + name) !== null) {
    //get the current value
    let currentValue: string | null = window.sessionStorage.getItem(
      config.STORAGE_ROOT + name
    );
    if (currentValue !== null) {
      //convert to object
      store = JSON.parse(currentValue);
    }
  } else {
    createStore(name);
    getStore(name);
  }

  return store;
};

export const setStore = (store: any, name: string): void => {
  //update the sessionStorage
  if (window.sessionStorage.getItem(config.STORAGE_ROOT + name) !== null) {
    window.sessionStorage.setItem(
      config.STORAGE_ROOT + name,
      JSON.stringify(store)
    );
  }
};

export const deleteStore = (name: any): void => {
  if (window.sessionStorage.getItem(config.STORAGE_ROOT + name) !== null) {
    window.sessionStorage.removeItem(config.STORAGE_ROOT + name);
  }
};
